import React, { PureComponent } from 'react';

import { sortByKey } from '~/core/scripts/utils';
import Icon from '~/core/scripts/components/Icon';

class Table extends PureComponent {
  state = {
    isExpanded: false
  }

  onToggle = () => {
    this.setState({
      isExpanded: !this.state.isExpanded
    });
  }

  getStateName(state) {
    switch (state) {
      case 'Mecklenburg-Vorpommern': return 'Mecklenburg-Vorp.';
      default: return state;
    }
  }

  render() {
    const { title, data } = this.props;
    const { isExpanded } = this.state;

    const dataWithSum = data.map(d => {
      const data2018 = d['2018'] === '-' ? 0 : d['2018'];
      d.data2018 = data2018;
      d.sum = d['bis2017'] + data2018;
      return d;
    });

    const counts = dataWithSum.reduce((res, item) => {
      res['bis2017'] += item['bis2017'];
      res['2018'] += item.data2018;

      return res;
    }, {
      'bis2017': 0,
      '2018': 0
    });

    dataWithSum.sort(sortByKey('sum', false));

    const items = isExpanded ? dataWithSum : dataWithSum.filter((d, i) => i < 3);
    const fullWidth = dataWithSum[0].sum;
    const expandIcon = isExpanded ? 'up' : 'down';

    return (
      <div className="table">
        <div className="table__head">
          <div className="table__title">
            {title}
          </div>
          <div className="table__col">
            <div className="table__col-title accentCol">
              bis 2017
            </div>
            <div className="table__col-title">
              2018
            </div>
          </div>
        </div>
        <div className="table__sum">
          <div className="table__sum-title">
            Gesamt
          </div>
          <div className="table__sum-counts">
            <div className="table__col-title accentCol">
              {counts['bis2017']}
            </div>
            <div className="table__col-title">
              {counts['2018']}
            </div>
          </div>
        </div>
        <div className="table__rows">
          {items.map((d, i) => (
            <div className="table__row" key={`${title}__${d.Bundesland}`}>
              <div className="table__row-index">{i + 1}.</div>
              <div className="table__row-state">{this.getStateName(d.Bundesland)}</div>
              <div className="table__row-bars">
                <div
                  className="table__row-bar bis2017"
                  style={{ width: `${(d['bis2017'] / fullWidth) * 100}%` }}
                />
                <div
                  className="table__row-bar ab2018"
                  style={{ width: `${(d.data2018 / fullWidth) * 100}%` }}
                />
              </div>
              <div className="table__row-2017 accentCol">
                {d['bis2017']}
              </div>
              <div className="table__row-2018">
                {d['2018']}
              </div>
            </div>
          ))}
        </div>
        <div className="table__expand" onClick={this.onToggle}>
          {isExpanded ? 'Weniger anzeigen' : 'Alle Bundesländer anzeigen'} <Icon type={expandIcon} />
        </div>
      </div>
    );
  }
}

export default Table;
